// src/pages_unauth/SigninPage.js
import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./SignupPage.css";
import { FcGoogle } from "react-icons/fc";
import { FaApple } from "react-icons/fa";
import { useAuth } from "../context/AuthContext";
import { Capacitor } from "@capacitor/core";
import { getUserConsentStatus } from "../data/accountRepo";
import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";
import { ReactComponent as AprendoleIcon } from "../icons/AprendoleIcon5.svg";

export default function SigninPage() {
  const { signInEmailPassword, signInWithGooglePopup, signInWithApple } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const isNative = Capacitor.isNativePlatform();

  // Handle Google redirect result
  // useEffect(() => {
  //   getRedirectResult(auth)
  //     .then(async (result) => {
  //       console.log("Google redirect result:", result);
  //       if (result && result.user) {
  //         const user = result.user;
  //         console.log("✅ Signed in:", user.email);
  
  //         await setDoc(
  //           doc(db, "users", user.uid),
  //           {
  //             name: user.displayName || "",
  //             email: user.email,
  //             createdAt: new Date(),
  //           },
  //           { merge: true }
  //         );
  
  //         navigate("/dashboard-v2");
  //       }
  //     })
  //     .catch((err) => console.error("Google redirect error", err));
  //   console.log("Current user after redirect:", auth.currentUser);
  // }, [auth, navigate]);
  

  const handleSignin = async (e) => {
    e.preventDefault();
    setError("");

    if (isOffline) return;

    try {
      const user = await signInEmailPassword(email, password);

      if (analytics) {
        logEvent(analytics, "login", { method: "email" });
      }

      if (!user.emailVerified) {
        navigate("/verify-email");
      } else {
        navigate("/home");
      }
    } catch (err) {
      setError("Invalid email or password");
    }
  };
  

  const handleGoogleSignin = async () => {
    setError("");

    if (isOffline) return;

    try {
      await signInWithGooglePopup();

      if (analytics) {
        logEvent(analytics, "login", { method: "google" });
      }
      // redirect happens; no further code runs here
    } catch (err) {
      console.error("Google sign-in error", err);
      setError("Erro ao continuar com Google. Tente novamente.");
    }
  };

  const handleAppleSignin = async () => {
    setError("");

    if (isOffline) return;

    try {
      await signInWithApple();


      if (analytics) {
        logEvent(analytics, "login", { method: "apple" });
      }
      // You can navigate here, or rely on your auth guards. Pick one style and stay consistent.
      // navigate("/home");
    } catch (err) {
      console.error("Apple sign-in error", err);
      setError("Erro ao continuar com Apple. Tente novamente.");
    }
  };

  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  
  if (isNative) {
    return (
      <div className="mobile-signup-page">
      <div className="mobile-signup-container">
        <div className="mobile-signup-top">
          <AprendoleIcon className="mobile-signup-logo" />
          {/* <p className="mobile-signup-subtitle">Aprenda alemão com histórias reais</p> */}
          <h1 className="mobile-signup-title">Bem-vindo de volta</h1>
        </div>

        {isOffline && (
            <div className="offline-banner">
              <span>Sem internet. Verifique sua conexão</span>
            </div>
          )}

        <form className="mobile-signup-form" onSubmit={handleSignin}>
          <input
            type="email"
            placeholder="E-mail"
            className="mobile-signup-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Senha"
            className="mobile-signup-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          {error && <p className="mobile-signup-error">{error}</p>}

          <button type="submit" className="mobile-signup-btn-primary">
            Entrar
          </button>
        </form>

        <div className="mobile-signup-divider">
          <span className="mobile-signup-divider-line" />
          <span className="mobile-signup-divider-text">ou</span>
          <span className="mobile-signup-divider-line" />
        </div>

        <div className="mobile-signup-social">
          <button
            className="mobile-signup-btn-apple"
            onClick={handleAppleSignin}
            type="button"
          >
            <FaApple className="mobile-signup-social-icon" />
            <span>Continuar com Apple</span>
          </button>

          <button
            className="mobile-signup-btn-google"
            onClick={handleGoogleSignin}
            type="button"
          >
            <FcGoogle className="mobile-signup-social-icon" />
            <span>Continuar com Google</span>
          </button>

          <Link to="/reset-password" className="mobile-signup-password-forget">
            Esqueceu a senha?
          </Link>
        </div>

        <div className="mobile-signup-footer">
          <p className="mobile-signup-account">
            Ainda não tem uma conta?{" "}
            <a href="/signup" className="mobile-signup-link">Cadastre-se</a>
          </p>
        </div>
      </div>
      </div>
    );
  }
  
  // web layout

  return (
    <div className="sign-in-container">
      <div className="sign-card">
        <h2 className="sign-header">Bem-vindo de volta!</h2>

        {/* Email login form */}
        <form className="sign-form" onSubmit={handleSignin}>
          <input
            type="email"
            placeholder="E-mail"
            className="sign-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Senha"
            className="sign-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" className="sign-button">
            Entrar
          </button>
        </form>

        {/* Divider */}
        <div className="sign-divider">
          <span className="sign-line"></span>
          <span className="sign-or">OU</span>
          <span className="sign-line"></span>
        </div>

        {isNative && (
            <div className="sign-google-container">
            <button
                className="apple-signin-btn"
                onClick={handleAppleSignin}
                aria-label="Continuar com Apple"
              >
                <FaApple className="sign-provider-icon" />
                <span className="sign-provider-text">Continuar com Apple</span>
              </button>
            </div>
            )}

        {/* Google sign-in */}
        <div className="sign-google-container">
          <button
              className="sign-google-button"
              onClick={handleGoogleSignin}
              type="button"
            >
              <FcGoogle className="sign-provider-icon" />
              <span className="sign-provider-text">Continuar com Google</span>
            </button>
        </div>

        {error && <p className="error">{error}</p>}

        <p className="sign-account-text">
            Ainda não tem uma conta?{" "}
              <a href="/signup" className="sign-link">
              Cadastre-se
              </a>
        </p>
      </div>

  

      <div className="sign-forgot-wrapper">
              <Link to="/reset-password" className="sign-forgot-link">
                Esqueceu a senha?
              </Link>
            </div>
    </div>
  );
}

